// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z2Y_7gCtPZUWApMO {
    display: flex;
    flex-direction: column;
    gap: var(--lok-spacing-7);
    padding: var(--lok-spacing-7);
    height: 500px;
    max-width: 640px;
    overflow: hidden;
}

.L0W2wCiqCAqZ8DY3 {
    font: var(--lok-typography-heading-4);
}

.ymL8vPxi9WsIJ4Uh {
    display: flex;
    flex-direction: column;
    gap: var(--lok-spacing-6);
    padding: var(--lok-spacing-5);
    border-radius: var(--lok-radius-l);
    background-color: var(--lok-color-background-surface-middle);
}

.rMpgGQjlc5IcgVF0 {
    color: var(--lok-color-text-light-default);
    font: var(--lok-typography-body-caption-default);
}

/* Shrinks the full EvaluationMetricsTable down into a small preview for the upsell. */
.mK7kggKZafg97Txz {
    flex: 1;
    position: relative;

    td {
        font-size: 7px !important;
        padding: 7px 6px 7px 5px;
    }

    th {
        font-size: 7px !important;
        padding: 7px 40px;
    }

    svg {
        width: 7px;
    }
}

.Syz3EEaOVE07LpcJ {
    position: absolute;
    width: 550px;
    border-radius: var(--lok-radius-l);
    box-shadow: 0px 10px 20px 2px #26262605,
                0px 8px 16px 0px #2626260A,
                0px 4px 6px 0px #2626260A,
                0px 0px 2px 0px #2626261A;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/UserCreatedProfileModal/components/UpsellEvaluationStep/UpsellEvaluationStep.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,kCAAkC;IAClC,4DAA4D;AAChE;;AAEA;IACI,0CAA0C;IAC1C,gDAAgD;AACpD;;AAEA,sFAAsF;AACtF;IACI,OAAO;IACP,kBAAkB;;IAElB;QACI,yBAAyB;QACzB,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC;;;yCAGqC;AACzC","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    gap: var(--lok-spacing-7);\n    padding: var(--lok-spacing-7);\n    height: 500px;\n    max-width: 640px;\n    overflow: hidden;\n}\n\n.title {\n    font: var(--lok-typography-heading-4);\n}\n\n.contents {\n    display: flex;\n    flex-direction: column;\n    gap: var(--lok-spacing-6);\n    padding: var(--lok-spacing-5);\n    border-radius: var(--lok-radius-l);\n    background-color: var(--lok-color-background-surface-middle);\n}\n\n.captionText {\n    color: var(--lok-color-text-light-default);\n    font: var(--lok-typography-body-caption-default);\n}\n\n/* Shrinks the full EvaluationMetricsTable down into a small preview for the upsell. */\n.tableContainer {\n    flex: 1;\n    position: relative;\n\n    td {\n        font-size: 7px !important;\n        padding: 7px 6px 7px 5px;\n    }\n\n    th {\n        font-size: 7px !important;\n        padding: 7px 40px;\n    }\n\n    svg {\n        width: 7px;\n    }\n}\n\n.tableInner {\n    position: absolute;\n    width: 550px;\n    border-radius: var(--lok-radius-l);\n    box-shadow: 0px 10px 20px 2px #26262605,\n                0px 8px 16px 0px #2626260A,\n                0px 4px 6px 0px #2626260A,\n                0px 0px 2px 0px #2626261A;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Z2Y_7gCtPZUWApMO`,
	"title": `L0W2wCiqCAqZ8DY3`,
	"contents": `ymL8vPxi9WsIJ4Uh`,
	"captionText": `rMpgGQjlc5IcgVF0`,
	"tableContainer": `mK7kggKZafg97Txz`,
	"tableInner": `Syz3EEaOVE07LpcJ`
};
export default ___CSS_LOADER_EXPORT___;
